import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

//components
import Table from "../../Components/TableTemplate/DataTable";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";
import Select from "react-select";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";
import toast from "react-hot-toast";
import { toastStyle, refreshPage, isAdmin, selectDropdownStyle, dateFormat } from "../../Helpers/Utils/Common";
import InputError from "../../Components/InputError/InputError";
import { createTerminal, deleteTerminals, searchTerminal, updateTerminal } from "../../Helpers/apiCalls/Manage/terminals";
import { getAllBranches } from "../../Helpers/apiCalls/Manage/Branches";
import { validatePriceLevels } from "../../Helpers/Validation/Manage/TerminalsValidation";
import { createPriceLevel, deletePriceLevel, searchPriceLevel, updatePriceLevel } from "../../Helpers/apiCalls/Manage/PriceLevels";
import Footer from "../../Components/Footer/Footer";

export default function Terminals() {
    const [inactive, setInactive] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [filterConfig, setFilterConfig] = useState({});

    // MODALS //
    // DELETE
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // VIEW
    const [showViewTerminalModal, setShowViewTerminalModal] = useState(false);
    const handleShowViewTerminalModal = () => setShowViewTerminalModal(true);
    const handleCloseViewTerminalModal = () => setShowViewTerminalModal(false);

    // EDIT
    const [showEditTerminalModal, setShowEditTerminalModal] = useState(false);
    const handleShowEditTerminalModal = () => setShowEditTerminalModal(true);
    const handleCloseEditTerminalModal = () => setShowEditTerminalModal(false);

    // ADD
    const [showAddTerminalModal, setShowAddTerminalModal] = useState(false);
    const handleShowAddTerminalModal = () => setShowAddTerminalModal(true);
    const handleCloseAddTerminalModal = () => setShowAddTerminalModal(false);

    //ERROR HANDLING
    const [isError, setIsError] = useState({
        bank_name: false,
        account_name: false,
        account_no: false,
    });

    //API
    const [allData, setAllData] = useState([]);
    const [branches, setBranches] = useState([]);
    const [allBranches, setAllBranches] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [addDetails, setAddDetails] = useState({
        name: "",
        branch_id: "",
        details: "",
        status: "active",
    });

    const handleAddChange = (e, search) => {
        if (search) {
            setAddDetails((prevState) => ({
                ...prevState,
                [e.var_name]: e.value,
                [e.for]: {
                    label:e.label,
                    value:e.value,
                    name:e.name,
                },
            }));
        } else {
            const { name, value } = e.target;
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    //DROPDOWN
    function handleSelectChange(e, row) {
        
        setSelectedRow(row);

        if (e.target.value === "delete") {
            handleShowDeleteModal();
        } else if (e.target.value === "edit") {
            setAddDetails(row);
            handleShowEditTerminalModal();
        }
        setShowLoader(false);
    }

    function ActionBtn(row) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action form-select"
                id={row.id}
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option defaulValue selected hidden>
                    Select
                </option>
                {isAdmin() && (
                    <option value="edit" className="color-options">
                        Edit
                    </option>
                )}
                {isAdmin() && (
                    <option value="delete" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }

    // async function fetchBranches() {
    //     setBranches([]);
    //     const response = await getAllBranches();
    //     if (response.data) {
    //         var filteredBranches = response.data.data.data.filter((company) => { return company.is_franchise === "0"})
    //         // var filteredBranches = response.data.data.data
    //         .map((data) => {
    //             var branch = data;
    //             branch.label = data.name;
    //             branch.value = data.id;
    //             branch.var_name = "branch_id";
    //             branch.for = "branch_id_value";
    //             return branch;
    //         });
    //         setBranches(filteredBranches);

    //         var allBranches = response.data.data.data.filter((company) => { return company.is_franchise === "0"})
    //         .map((data) => {
    //             var branch = data;
    //             branch.label = data.name;
    //             branch.value = data.id;
    //             branch.for = "branch_id_value";
    //             return branch;
    //         });
    //         setAllBranches([{ label: "All Branches", value: "" }, ...allBranches]);
    //     }
    // }

    async function handleCreatePriceLevel() {
        if (validatePriceLevels(addDetails, setIsError)) {
            setIsClicked(true);
            const response = await createPriceLevel(addDetails);
            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
            setIsClicked(false);
        }
    }

    async function fetchPriceLevels() {
        setShowLoader(true);
        setAllData([]);
        const response = await searchPriceLevel(filterConfig);
        if (response.data) {
            let result = response.data.data.map((data) => {
                var info = data
                info.added_on = dateFormat(data.added_on)
                return info
            });
            setAllData(result);
        }
        setShowLoader(false);
    }

    async function handleDeletePriceLevel() {
        setIsClicked(true);
        const response = await deletePriceLevel(selectedRow.id);
        
        if (response.data) {
            toast.success(response.data.message, {
                style: toastStyle(),
            });
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
        }
        setTimeout(() => refreshPage(), 1000);
    }

    async function handleUpdatePriceLevel() {
        if (validatePriceLevels(addDetails, setIsError)) {
          const response = await updatePriceLevel(addDetails);
          setIsClicked(true);
          if (response.data) {
              toast.success(response.data.message, {
                  style: toastStyle(),
              });
              setShowEditTerminalModal(false);
          } else {
              response.error?.response?.data?.messages.map((data) => {
                  return toast.error(data);
              })
          }
          setIsClicked(true);
          // setTimeout(() => refreshPage(), 1000);
        }
    }

    useEffect(() => {
        fetchPriceLevels();
        // fetchBranches()
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"MANAGE ITEM"}
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ITEM PRICE LEVELS </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            className="search-bar"
                            defaultValue=""
                            name="name"
                            placeholder="Search name..."
                            // onChange={(e) => setSearchBankName(e.target.value)}
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") &&
                                    setFilterConfig((prev) => {
                                        return { ...prev, name: e.target.value };
                                    })
                            }
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                        <button
                            className="add-btn"
                            onClick={handleShowAddTerminalModal}
                        >
                            Add
                        </button>
                        </div>
                    </Col>
                </Row>

                {/* TABLE */}
                <div className="tab-content">
                  {/* <div className="my-2 ms-2 PO-filters PI-filters d-flex">
                      <span className="me-3 align-middle mt-2">Filter By:</span>
                      <Select
                        className="dropsearch-filter px-0 py-0 me-2"
                        classNamePrefix="react-select"
                        placeholder="Select Branch"
                        styles={selectDropdownStyle}
                        options={allBranches}
                        onChange={(e) => {
                        setFilterConfig((prev) => {
                            return { ...prev, branch_id: e.value };
                        });
                        }}
                      />
                  </div> */}
                  <Table
                    tableHeaders={[
                      "NAME",
                      "DESCRIPTION",
                      "ADDED ON",
                      "ACTIONS",
                    ]}
                    headerSelector={[
                      "name",
                      "description",
                      "added_on",
                    ]}
                    tableData={allData}
                    showLoader={showLoader}
                    ActionBtn={(row) => ActionBtn(row)}
                  />
                </div>
            </div>

            {/* MODALS */}
            <DeleteModal
                text="price level"
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onDelete={() => handleDeletePriceLevel()}
                isClicked={isClicked}
            />
            <AddModal
                title="PRICE LEVEL"
                size="lg"
                type="terminal"
                show={showAddTerminalModal}
                onHide={handleCloseAddTerminalModal}
                onSave={() => handleCreatePriceLevel()}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                  <Row className="nc-modal-custom-row mt-0">
                    <Col xs={12} lg={6}>
                      NAME
                      <span className="required-icon">*</span>
                      <Form.Control
                          type="text"
                          name="name"
                          value={addDetails.name}
                          className="nc-modal-custom-input"
                          onChange={(e) => handleAddChange(e)}
                          required
                      />
                      <InputError
                          isValid={isError.name}
                          message={"Name is required"}
                      />
                    </Col>
                    <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                      DESCRIPTION
                      <Form.Control
                          type="text"
                          name="description"
                          value={addDetails.description}
                          className="nc-modal-custom-input"
                          onChange={(e) => handleAddChange(e)}
                          required
                      />
                    </Col>
                  </Row>
                </div>
            </AddModal>
            <EditModal
                title="PRICE LEVEL"
                size="lg"
                type="terminal"
                show={showEditTerminalModal}
                onHide={handleCloseEditTerminalModal}
                onSave={handleUpdatePriceLevel}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                  <Row className="nc-modal-custom-row mt-0">
                    <Col xs={12} lg={6}>
                      NAME
                      <span className="required-icon">*</span>
                      <Form.Control
                          type="text"
                          name="name"
                          value={addDetails.name}
                          className="nc-modal-custom-input"
                          onChange={(e) => handleAddChange(e)}
                          required
                      />
                      <InputError
                          isValid={isError.name}
                          message={"Name is required"}
                      />
                    </Col>
                    <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                      DESCRIPTION
                      <Form.Control
                          type="text"
                          name="description"
                          value={addDetails.description}
                          className="nc-modal-custom-input"
                          onChange={(e) => handleAddChange(e)}
                          required
                      />
                    </Col>
                  </Row>
                </div>
            </EditModal>
            <Footer/>
        </div>
    );
}
